import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mt-2 mb-2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "separator separator-dashed" }, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3));
}
